import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInbox } from "@fortawesome/free-solid-svg-icons";

const EmptyState = ({
  title = "No records found",
  message = "Try adjusting your search or filters",
  icon = faInbox,
  className = "",
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-2 w-full ${className}`}
    >
      <FontAwesomeIcon icon={icon} className="text-gray-500 h-8 w-8" />
      <div className="text-gray-600 text-sm font-medium">{title}</div>
      <p className="text-gray-600 text-sm">{message}</p>
    </div>
  );
};

export default EmptyState;
